export default "__VITE_ASSET__7C2nc9UJ__"